<table class="table participants clickable">
    <thead>
        <tr>
            <th></th>
            <th>{{ 'form.social-name' | translate }}</th>
            <th class="d-none d-md-table-cell">
                {{ 'form.document' | translate }}
            </th>
            <th class="text-right" *ngIf="!isAdmin">
                {{ 'form.status' | translate }}
            </th>
            <th class="text-right" *ngIf="isAdmin">
                {{ 'form.validated' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
            <tr (click)="onEdit(participant)" *ngIf="isFirst">
                <td>
                    <i class="icon-legal"></i>
                </td>
                <td>
                    <strong>{{ participant.name }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ participant.docId }}</strong>
                </td>
                <td *ngIf="!isAdmin">
                    <i class="icon-check green-icon-check float-right" *ngIf="participant.isComplete(isGDC)"></i>
                    <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!participant.isComplete(isGDC)"></i>
                </td>
                <td *ngIf="isAdmin">
                    <i class="icon-check green-icon-check float-right" *ngIf="participant.isValidated(isAdminPBC) || participant.validation.isValid()"></i>
                    <i class="icon-exclamation red-icon-exclamation float-right" *ngIf="!participant.isValidated(isAdminPBC) && !participant.validation.isValid()"></i>
                </td>
            </tr>
        </ng-template>
    </tbody>
</table>
